import React, { Component } from "react";
import MaterialTable from "material-table";
import { withStyles, IconButton, Tooltip, Paper } from "@material-ui/core";

import Icon from "@jll/icon";
import { styles } from "./styles";
import { TableHeader } from "./tableHeader";
import { NavLink } from "react-router-dom";
import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";

import CustomMTableHeader from "../../../../Component/Table/CustomMTableHeader";
import CustomMTableRow from "../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../Component/Table/CustomMTableCell";
import CustomMTableActions from "../../../../Component/Table/CustomMTableActions";
import Pagination from "../../../../Component/Pagination";

import { withTranslation } from "react-i18next";

class ChecksTable extends Component {
  state = {
    pageSize: 0,
  };

  render() {
    const {
      classes,
      data,
      totalItemsCount,
      rowsPerPage,
      pageNumber,
      handlePagination,
      handleRowsPerPageChange,
      onReqestAllocationClick,
      t,
      handelCancelCheck,
    } = this.props;

    return (
      <div className={classes.checksTableContainer}>
        <MaterialTable
          style={tableStyle}
          icons={tableIcons}
          elevation="0"
          options={tableOptions}
          isLoading={false}
          data={data}
          columns={TableHeader(t)}
          localization={{
            header: {
              actions: t("labels.common.table.noRecordsFound"),
            },
            body: {
              emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
            },
          }}
          actions={[
            {
              icon: "view",
              position: "row",
              onClick: () => {},
            },
            {
              icon: "allocate",
              position: "row",
              onClick: (event, record) => {
                onReqestAllocationClick(record);
              },
            },
            {
              icon: "cancel",
              position: "row",
              onClick: (event, record) => {
                handelCancelCheck(record);
              },
            },
            {
              icon: "restart",
              position: "row",
              onClick: (event, record) => {
                handelCancelCheck(record);
              },
            },
          ]}
          components={{
            Container: (props) => <Paper {...props} elevation={0} />,
            Actions: (props) => <CustomMTableActions {...props} />,
            Action: (props) => {
              switch (props.action.icon) {
                case "view":
                  return props.data.canView ? (
                    <Tooltip
                      title={t("labels.checks.table.actions.viewDetails")}
                      placement="bottom"
                    >
                      <NavLink to={`/viewCheck?id=` + props.data.entityId}>
                        <IconButton className={classes.actionIcons}>
                          <Icon
                            className="far fa-arrow-circle-right"
                            style={{ fontSize: 16 }}
                          />
                        </IconButton>
                      </NavLink>
                    </Tooltip>
                  ) : (
                    ""
                  );
                case "allocate":
                  return props.data.canAllocate ? (
                    <Tooltip
                      title={t("labels.checks.table.actions.allocate")}
                      placement="bottom"
                    >
                      <IconButton
                        onClick={(event) =>
                          props.action.onClick(event, props.data)
                        }
                        className={classes.actionIcons}
                      >
                        <Icon
                          className="far fa-user-tag"
                          style={{ fontSize: 16 }}
                        />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    ""
                  );
                case "cancel":
                  return props.data.canCancel ? (
                    <Tooltip
                      title={t("labels.checks.table.actions.cancel")}
                      placement="bottom"
                    >
                      <IconButton
                        onClick={(event) =>
                          props.action.onClick(event, props.data)
                        }
                        className={classes.actionIcons}
                      >
                        <Icon
                          className="fas fa-times-circle"
                          style={{ fontSize: 16 }}
                        />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    ""
                  );
                case "restart":
                  return props.data.canRestart ? (
                    <Tooltip
                      title={t("labels.checks.table.actions.restart")}
                      placement="bottom"
                    >
                      <IconButton
                        onClick={(event) =>
                          props.action.onClick(event, props.data)
                        }
                        className={classes.actionIcons}
                      >
                        <Icon
                          className="fas fa-play"
                          style={{ fontSize: 16 }}
                        />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    ""
                  );
                default:
                  return null;
              }
            },
            Header: (props) => <CustomMTableHeader {...props} />,
            Row: (props) => <CustomMTableRow {...props} />,
            Cell: (props) => <CustomMTableCell {...props} />,
          }}
        />
        <Pagination
          handleRowsPerPage={handleRowsPerPageChange}
          rowsPerPage={rowsPerPage}
          pageNumber={pageNumber}
          handlePagination={handlePagination}
          totalItemsCount={totalItemsCount}
        ></Pagination>
      </div>
    );
  }
}

export default withTranslation()(
  withStyles(styles, { withTheme: true })(ChecksTable),
);
